import { motion } from "framer-motion";
import {
  Car,
  Wifi,
  BellRing,
  Sparkles,
  ShieldCheck,
  Users,
  MapPin,
  Coffee,
} from "lucide-react";
import { AMENITIES } from "../data/site";

const ICONS = { Car, Wifi, BellRing, Sparkles, ShieldCheck, Users, MapPin, Coffee };

export default function Amenities() {
  return (
    <section
      id="amenities"
      data-testid="amenities-section"
      className="section-padding bg-background"
    >
      <div className="container-x">
        <div className="max-w-2xl">
          <span className="eyebrow">What's Included</span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl leading-tight text-foreground">
            Thoughtful amenities,<br />
            <span className="italic text-[#7A1A24] dark:text-[#D4AF37]">all part of your stay.</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
          {AMENITIES.map((a, i) => {
            const Icon = ICONS[a.icon] || Sparkles;
            return (
              <motion.div
                key={a.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ delay: i * 0.06, duration: 0.55 }}
                whileHover={{ y: -4 }}
                data-testid={`amenity-${a.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group relative rounded-2xl border border-border bg-card p-6 overflow-hidden transition-colors hover:border-[#D4AF37]/60"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-[#D4AF37]/0 via-transparent to-[#7A1A24]/0 group-hover:from-[#D4AF37]/8 group-hover:to-[#7A1A24]/6 transition-colors duration-500" />
                <div className="relative">
                  <div className="h-11 w-11 rounded-xl bg-[#7A1A24]/10 dark:bg-[#D4AF37]/10 text-[#7A1A24] dark:text-[#D4AF37] grid place-items-center transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3">
                    <Icon size={20} strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-5 font-display text-lg text-foreground">{a.title}</h3>
                  <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">
                    {a.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
